import React, { useState, useEffect } from 'react';
import { Typography, Button, Row, Col, message } from 'antd';

const { Title, Paragraph } = Typography;

const UploadSuccess = () => {
    const [referralCode, setReferralCode] = useState('Loading...');

    // Simulate fetching the referral code from an API
    useEffect(() => {
        setTimeout(() => {
            const user = localStorage.getItem("user");
            const parsedUser = JSON.parse(user);

            setReferralCode(parsedUser.refer_code); // Replace with actual API response
        }, 1000);
    }, []);

    const copyReferralCode = () => {
        navigator.clipboard.writeText(referralCode).then(() => {
            message.success('Referral code copied to clipboard!');
        }).catch(() => {
            message.error('Failed to copy referral code.');
        });
    };

    return (
        <div style={{ margin: '50px 0' }}>
            {/* Success Message */}
            <div style={{ padding: '50px 0', backgroundColor: '#f9f9f9' }}>
                <div style={{ padding: '50px', maxWidth: '1200px', margin: '0 auto' }}>
                    <div>
                        <h2 style={{ textAlign: 'center', marginBottom: '20px', fontSize: '2rem' }}>
                            Registration and Video Upload is Successful
                        </h2>
                        <p style={{ textAlign: 'center', marginBottom: '40px', fontSize: '1rem', color: '#555' }}>
                            Last date to register in Campaign is 25 January 2025. All services will be
                            activated after the completion of Nasha Mukti Campaign.
                        </p>
                    </div>
                </div>
            </div>

            {/* Referral Code Section */}
            <div style={{ padding: '50px 0', backgroundColor: '#f4f4f4' }}>
                <div style={{ padding: '50px', maxWidth: '1200px', margin: '0 auto' }}>
                    <div>
                        <h3 style={{ textAlign: 'center', marginBottom: '10px', fontSize: '1.5rem' }}>
                            Your Referral Code
                        </h3>
                        <div style={{ textAlign: 'center', margin: '20px 0' }}>
                            <p
                                id="referralCode"
                                style={{
                                    fontSize: '20px',
                                    fontWeight: 'bold',
                                    color: '#333',
                                    margin: '10px 0',
                                }}
                            >
                                {referralCode}
                            </p>
                            <button
                                type="button"
                                onClick={copyReferralCode}
                                style={{
                                    padding: '10px 20px',
                                    backgroundColor: '#a6cc43',
                                    color: '#fff',
                                    border: 'none',
                                    borderRadius: '5px',
                                    cursor: 'pointer',
                                    fontSize: '16px',
                                }}
                            >
                                Copy Code
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default UploadSuccess;
